import React, {
  ReactElement, useEffect, useRef,
} from 'react';
import classNames from 'classnames';
import { LoaderButton } from 'idsk-react-components';
import iconDown from '../../../assets/images/icon-arrow-down.svg';
import iconUp from '../../../assets/images/icon-arrow-up.svg';
import './dropdown.scss';

interface Props {
  title: string,
  isDropdownOpened: boolean,
  setIsDropdownOpened: (isDropdownOpened: boolean) => void,
  loading?: boolean
  children?: ReactElement
}

const Dropdown = ({
  title, isDropdownOpened, setIsDropdownOpened, loading, children,
}: Props): ReactElement => {
  const drop = useRef(null);
  const ulRef = useRef(null);
  const classes: string = classNames(
    'dropdown__content',
    !isDropdownOpened && 'dropdown__content-hidden',
  );

  const onClick = (): void => {
    setIsDropdownOpened(!isDropdownOpened);
  };

  const handleClick = (e: MouseEvent): void => {
    if (drop.current && !drop.current.contains(e.target)) {
      setIsDropdownOpened(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drop]);

  function buttonIcon(): string {
    if (loading) {
      return null;
    }
    if (isDropdownOpened) {
      return iconUp;
    }
    return iconDown;
  }

  return (
    <div ref={drop} className="dropdown">
      <LoaderButton
        className="dropdown__button"
        buttonStyle="third"
        size="large"
        loading={loading}
        onClick={onClick}
        customIconAfter={buttonIcon()}
        disableOutsideClickWhileLoading
      >
        {title}
      </LoaderButton>
      {children && (
        <div ref={ulRef} className={classes}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
